import { Flex, Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import HeaderLayout from './HeaderLayout';
import SideBarLayout from './SideBarLayout';
import { HeaderReset } from '@/v1/components/Header/HeaderReset';
import { usePageTransition } from '@/v1/hooks/usePageTransition';

const { Content } = Layout;

export default function AppLayout() {
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);

  // Use page transition hook for better navigation handling
  usePageTransition();

  // Simplified scroll reset - only handle content ref specific logic
  useEffect(() => {
    if (contentRef.current) {
      // Ensure the content container is reset
      contentRef.current.scrollTo({
        top: 0,
        behavior: 'instant',
      });
    }
  }, [location.pathname]);

  return (
    <>
      <HeaderReset />
      <Flex className="flex-row h-screen">
        {/* Sidebar */}
        <SideBarLayout />
        {/* Main Container */}
        <Flex className="flex-col w-[calc(100%-270px)] h-full overflow-hidden">
          <Content
            ref={contentRef}
            className="flex flex-col overflow-auto custom-scroll min-w-[1088px] w-[88%] my-0 mx-auto max-[1370px]:min-w-[940px] max-[1370px]:w-[95%] max-[1200px]:min-w-[auto] py-8 h-full px-6"
          >
            <HeaderLayout />
            <div
              className="mt-8 grid main-content-container relative z-10"
              id="main-content"
            >
              <div className="page-content">
                <Outlet />
              </div>
            </div>
          </Content>
        </Flex>
      </Flex>
    </>
  );
}
